module.exports = __webpack_public_path__ + "static/media/csv-preview-us.3ab15c7f.png";